import { __decorate, __metadata, __param } from "tslib";
import _, { trim } from 'lodash';
import { inject, injectable } from 'inversify';
import { maybeFillArrayFiled, maybeFillField } from '../utils/lang';
import { E_ACCOUNT_STATUS } from '../apis/service/AccountApi.types';
import { Symbols } from '@/symbols';
import { E_ComponentVariant } from '@/constants/ui';
import { BooleanEx } from '@/@core/utils/boolex';
import { splitAccountGroup } from '@/utils/emails';
import { getBeisenUser } from '@/utils/beisen';
import { E_ExpiredPrivilegeOptions } from './CompanyBase/CompanyService';
// re-export
// export * from '../apis/service/AccountApi.types'
var E_TIP_ICON;
(function (E_TIP_ICON) {
    E_TIP_ICON["question"] = "question-circle";
    E_TIP_ICON["check"] = "check-circle";
    E_TIP_ICON["info"] = "info-circle";
    E_TIP_ICON["warning"] = "exclamation-circle";
})(E_TIP_ICON || (E_TIP_ICON = {}));
function makeAccountStatusIconConfig() {
    return {
        class: '',
        tooltip: '',
        faIcon: null,
    };
}
let AccountService = class AccountService {
    constructor(accountApi, BoHelperService, i18n, authService) {
        this.accountApi = accountApi;
        this.BoHelperService = BoHelperService;
        this.i18n = i18n;
        this.authService = authService;
        this.updateAccountPrivilegeExcludeFeatures = (params) => {
            return this.accountApi.updateAccountPrivilegeExcludeFeatures(params);
        };
        /** 用户系统限制 */
        this.getSystemLimit = this.accountApi.getSystemLimit;
        this.patchSystemLimit = this.accountApi.patchSystemLimit;
    }
    convertListAccountParamsToReqParams(params = {}) {
        let { company_name_with_remark, emails, product_ids, account_id, account_type, account_status, package_ids, account_package_ids, credit_package_ids, credits_group_id, contract_number, company_id, mobile_number, s_end_at_start, s_end_at_end, s_last_login_start, s_last_login_end, s_created_at_start, s_created_at_end, s_self_trial, sales_emails, s_invitation_code, s_identifiers, s_hyper_link, s_last_login_status, user_role, openapi_administrator, account_type_list, account_status_list, s_enabled, s_contain_expired_privileges, } = params;
        company_name_with_remark = trim(company_name_with_remark);
        company_name_with_remark = company_name_with_remark || null;
        let paramsSend = {};
        maybeFillField(company_id, item => { paramsSend.s_company_id = item; });
        maybeFillField(company_name_with_remark, item => { paramsSend.s_name_company = item; });
        maybeFillField(account_status, item => { paramsSend.s_account_status = item; });
        maybeFillField(mobile_number, item => { paramsSend.s_mobile_number = item; });
        maybeFillField(emails, item => { paramsSend.s_email = item; });
        // maybeFillArrayFiled(emails, item => { paramsSend.s_email = item, ' ' })
        maybeFillArrayFiled(product_ids, item => { paramsSend.s_product_ids = item; });
        maybeFillArrayFiled(package_ids, item => { paramsSend.s_package_ids = item; });
        maybeFillArrayFiled(account_package_ids, item => { paramsSend.s_account_package_ids = item; });
        maybeFillArrayFiled(credit_package_ids, item => { paramsSend.s_credit_package_ids = item; });
        maybeFillField(credits_group_id, item => { paramsSend.s_credits_group_id = item; });
        maybeFillField(trim(contract_number), item => { paramsSend.s_contract_number = item; });
        maybeFillArrayFiled(sales_emails, item => { paramsSend.sales_emails = item; });
        paramsSend.account_type_list = account_type_list;
        paramsSend.account_status_list = account_status_list;
        maybeFillField(account_type, item => { paramsSend.s_account_type = account_type; });
        maybeFillField(account_id, item => { paramsSend.s_account_id = item; });
        maybeFillField(s_end_at_start, item => { paramsSend.s_end_at_start = item; });
        maybeFillField(s_end_at_end, item => { paramsSend.s_end_at_end = item; });
        maybeFillField(s_last_login_start, item => { paramsSend.s_last_login_start = item; });
        maybeFillField(s_last_login_end, item => { paramsSend.s_last_login_end = item; });
        maybeFillField(s_created_at_start, item => { paramsSend.s_created_at_start = item; });
        maybeFillField(s_created_at_end, item => { paramsSend.s_created_at_end = item; });
        maybeFillField(s_self_trial, item => { paramsSend.s_self_trial = BooleanEx.toBool(item); });
        maybeFillField(s_invitation_code, item => { paramsSend.s_invitation_code = item; });
        maybeFillField(s_identifiers, item => { paramsSend.s_identifiers = _.join(splitAccountGroup(item), ','); });
        maybeFillField(s_hyper_link, item => { paramsSend.s_hyper_link = item; });
        maybeFillField(s_last_login_status, item => { paramsSend.s_last_login_status = BooleanEx.toBool(item); });
        maybeFillField(user_role, item => { paramsSend.s_user_role = user_role; });
        maybeFillField(openapi_administrator, item => {
            paramsSend.s_openapi_administrator = openapi_administrator;
        });
        maybeFillField(s_enabled, item => { paramsSend.s_enabled = s_enabled; });
        maybeFillField(s_contain_expired_privileges, item => { paramsSend.s_contain_expired_privileges = s_contain_expired_privileges === E_ExpiredPrivilegeOptions.YES; });
        paramsSend = this.BoHelperService.maybeSerializeLocaleDate(paramsSend, 's_end_at_start', 's_end_at_end', 's_last_login_start', 's_last_login_end', 's_created_at_start', 's_created_at_end');
        const pageParms = _.pick(params, ['sEcho', 'iDisplayLength', 'iDisplayStart']);
        const paramsData = {
            ...paramsSend,
            ...pageParms,
        };
        return paramsData;
    }
    listAccounts(params = {}) {
        const paramsData = this.convertListAccountParamsToReqParams(params);
        window.rvTrack('Search Account List', paramsData);
        return this.accountApi.getListAccounts(paramsData);
    }
    getAccountTenantActionList(tenantUser, IsCompanyAccountList = false) {
        if (!IsCompanyAccountList) {
            if (!this.getCanViewAccountTenant(tenantUser)) {
                return ['resendWelcomeEmail', 'newTrial'];
            }
            if (_.isNil(tenantUser.tenant_id)) {
                return [
                    'newTrial',
                    'modifyUserPermissions',
                    'resendWelcomeEmail',
                    'close',
                    'revoke'
                ];
            }
        }
        return [
            'newTrial',
            'modifyUserPermissions',
            'resendWelcomeEmail',
            'fakeActive',
            'editRole',
            'remove',
            'close',
            'revoke'
        ];
    }
    getTenantsList(tenants) {
        return _.map(tenants, item => {
            return {
                ...item,
                tenant_id: item.tenant_id || 'null',
                tenant_name: item.tenant_name || this.i18n.t('backoffice.account.Individual'),
            };
        });
    }
    getEmailIconConfig(item, tenantUser) {
        const config = makeAccountStatusIconConfig();
        if (item.email_binding) {
            config.class = E_ComponentVariant.Success;
            config.tooltip = this.i18n.t('backoffice.account.emailBindActiveTip');
            config.faIcon = E_TIP_ICON.check;
        }
        else {
            const fakeActiveTenantList = [];
            const notFakeActiveTenantList = [];
            _.forEach(item.tenant_users, tenantUser => {
                if (tenantUser.tenant_id) {
                    if (tenantUser.fake_active) {
                        fakeActiveTenantList.push(tenantUser);
                    }
                    else {
                        notFakeActiveTenantList.push(tenantUser);
                    }
                }
            });
            // const fakeActive = _.find(item.tenant_users, tenantUser => !!tenantUser.fake_active)
            // 所有租户全部伪激活
            if (fakeActiveTenantList.length > 0 && notFakeActiveTenantList.length === 0) {
                config.class = E_ComponentVariant.Success;
                config.tooltip = this.i18n.t('backoffice.common.nonSelfVerified');
                config.faIcon = E_TIP_ICON.warning;
            }
            else if (fakeActiveTenantList.length > 0 && notFakeActiveTenantList.length > 0) {
                config.class = E_ComponentVariant.Warning;
                const tenantNames = _.map(notFakeActiveTenantList, 'tenant_name').join(',');
                config.tooltip = this.i18n.t('backoffice.common.notAllSelfVerified', { tenantNames });
                config.faIcon = E_TIP_ICON.warning;
            }
            else {
                config.class = E_ComponentVariant.Secondary;
                config.tooltip = this.i18n.t('backoffice.account.emailBindPendingTip');
                config.faIcon = E_TIP_ICON.question;
            }
        }
        return config;
    }
    getMobileIconConfig(item) {
        const config = makeAccountStatusIconConfig();
        if (item.mobile_binding) {
            config.class = E_ComponentVariant.Success;
            config.tooltip = this.i18n.t('backoffice.common.verified');
            config.faIcon = E_TIP_ICON.check;
        }
        else {
            config.class = E_ComponentVariant.Secondary;
            config.tooltip = this.i18n.t('backoffice.common.unverified');
            config.faIcon = E_TIP_ICON.question;
        }
        return config;
    }
    getAccountStatusTip(item) {
        const account_status = item.account_status_combine;
        if (account_status === E_ACCOUNT_STATUS.ACTIVE) {
            return this.i18n.t('backoffice.account.accountStatusActiveTip');
        }
        if (account_status === E_ACCOUNT_STATUS.PENDING) {
            return this.i18n.t('backoffice.account.accountStatusPendingTip');
        }
        if (account_status === E_ACCOUNT_STATUS.BLOCKED) {
            return this.i18n.t('backoffice.account.accountStatusBlockedTip', { disable_reason: item.disable_reason });
        }
    }
    getSalesName(tenant) {
        return getBeisenUser({
            defaultName: tenant.sales_name,
            departmentName: tenant.sales_department_name,
            employeeName: tenant.sales_employee_name,
        });
    }
    getCsName(tenant) {
        return getBeisenUser({
            defaultName: tenant.cs_name,
            departmentName: tenant.cs_department_name,
            employeeName: tenant.cs_employee_name,
        });
    }
    /**
     * 是否可查看用户信息
     * 销售只能查看自己名下的公司用户
     */
    getCanViewAccountTenant(item) {
        if (!this.authService.IsOnlyViewFlag) {
            return true;
        }
        if (item.belong) {
            return true;
        }
        return false;
    }
    getCanViewAccount(item) {
        if (!this.authService.IsOnlyViewFlag) {
            return true;
        }
        const belong = _.find(item.tenant_users, item => item.belong);
        if (belong) {
            return true;
        }
        return false;
    }
    getAccountTenantStatus(item) {
        const disabled = _.find(item.tenant_users, item => item.enabled === false);
        return !!disabled;
    }
    transformAccountProductPrivilegeItem(accountPrivilegeViewList) {
        return _.map(accountPrivilegeViewList, (el) => {
            const view = {
                account_privilege_id: el.account_privilege_id,
                company_privilege_id: el.company_privilege_id || '',
                /** 付费类型 */
                charge_mode: el.charge_mode,
                /** 开始、结束日期 **/
                // begin_at: el.begin_at,
                // end_at: el.end_at,
                /** 限制规则 */
                limitation_ways: el.limitation_ways || [],
                /** 权限的来源 */
                privilege_from: el.privilege_from,
                packages: el.packages,
                credits_roles: el.credits_roles,
                durations: el.durations || [],
                /** 总时长 */
                total_time: el.end_at - el.begin_at,
                company_id: el.company_id,
                business_package_enabled: !!el.business_package_enabled,
            };
            return view;
        });
    }
    /** 获取用户产品权限列表 */
    async getAccountProductPrivilege(params) {
        const privilegeList = await this.accountApi.getTenantUsersPrivilegeView(params);
        const effect_privilege_view = this.transformAccountProductPrivilegeItem(privilegeList.effect_privilege_view);
        const take_effect_privilege_view = this.transformAccountProductPrivilegeItem(privilegeList.take_effect_privilege_view);
        const expired_privilege_view = this.transformAccountProductPrivilegeItem(privilegeList.expired_privilege_view);
        return {
            effect_privilege_view,
            take_effect_privilege_view,
            expired_privilege_view,
        };
    }
    postRelieveSsoBinding(data) {
        if (data.key === 'google_bind_status') {
            return this.accountApi.postRelieveSocialBinding({
                account_id: data.user_id,
                source: 'GOOGLE',
            });
        }
        else if (data.key === 'feishu_social_bind_status') {
            return this.accountApi.postRelieveSocialBinding({
                account_id: data.user_id,
                source: 'FEISHU',
            });
        }
        else if (data.key === 'inno_cloud') {
            return this.accountApi.deleteInnoCloudBinding(data.user_id);
        }
        else if (data.key === 'mfa_bind_status') {
            return this.accountApi.deleteMfaUnbind(data.user_id);
        }
        else {
            const typeMapping = {
                dingtalk_bind_status: '0',
                wechat_bind_status: '1',
                feishu_bind_status: '2',
                saml_bind_status: '3',
            };
            const relieve_flag = typeMapping[data.key];
            return this.accountApi.postRelieveSsoBinding({
                tenant_user_id: data.tenant_user_id,
                tenant_id: data.tenant_id,
                relieve_flag,
            });
        }
    }
    getBeisenAccountByEmails(emails) {
        return this.accountApi.postBeisenAccountByEmails(emails);
    }
    getAccountBatchInfoSummary(accountIds) {
        return this.accountApi.getAccountBatchInfoSummary(accountIds);
    }
    postAccountAudit(params) {
        return this.accountApi.postAccountAudit(params);
    }
    exportUsers(params) {
        return this.accountApi.exportUsers(this.convertListAccountParamsToReqParams(params));
    }
};
AccountService = __decorate([
    injectable(),
    __param(0, inject(Symbols.AccountApi)),
    __param(1, inject(Symbols.BoHelperService)),
    __param(2, inject(Symbols.I18n)),
    __param(3, inject(Symbols.AuthService)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], AccountService);
export { AccountService };
